<template>
  <el-dialog
    id="bb"
    :center="true"
    :close-on-click-modal="false"
    title="模板设置"
    :visible.sync="showEdit"
    @close="closeEditDialog"
  >
    <el-form :rules="rules" ref="template" :model="template" label-width="100px">
      <el-form-item label="模板名称" style="width: 100%;">
        <el-input v-model="template.templateName" placeholder="请输入模板名称" style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="模板是否可上传文件" style="width: 100%;" label-width="150px">
        <el-radio-group v-model="template.templateType">
          <el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="template.templateType == 1" label="提示文案">
        <el-input v-model="template.tipsTitle" placeholder="请输入提示文案"></el-input>
      </el-form-item>
      <el-form-item label="模板状态">
        <el-radio-group v-model="template.templateStatus">
          <el-radio label="1">启用</el-radio>
          <el-radio label="2">失效</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="模板设置">
        <el-form-item style="margin-top: 10px;">
          <el-button icon="el-icon-circle-plus-outline" @click="addInput"></el-button>
          <el-button icon="el-icon-remove-outline" @click="removeItem"></el-button>
        </el-form-item>
      </el-form-item>
      <el-form-item style="margin-left: -99px;">
        <el-form-item v-for="(item,index) in template.templateArr" :key="index">
          <el-form-item :label="'问题'+(index + 1)">
            <el-input type="textarea"
                      :rows="2" v-model="item.question" size="small" style="width: 80%;"
                      placeholder="请输入问题"></el-input>
          </el-form-item>
          <el-form-item :label="'回答'+(index + 1)">
            <el-input type="textarea"
                      :rows="2" v-model="item.answer" size="small" style="width: 80%;"
                      placeholder="请输入回答"></el-input>
          </el-form-item>
        </el-form-item>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeEditDialog">取消</el-button>
            <el-button size="small" type="primary" @click="saveEditForm">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from '../../../config/api';

export default {
  components: {},
  data() {
    return {
      showEdit: false,
      rules: {},
      template: {
        templateName: '',
        templateStatus: '',
        templateType: '',
        tipsTitle: '',
        templateArr: [{
          question: '',
          answer: ''
        }]
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    //添加输入框
    addInput() {
      this.template.templateArr.push({
        question: '',
        answer: '',
      })
    },
    //减少输入框
    removeItem() {
      if (this.template.templateArr.length > 1) {
        this.template.templateArr.pop()
      } else {
        this.template.templateArr.splice(0, this.template.templateArr.length)
      }
    },
    init() {
      this.showEdit = true
      this.template.templateName = ''
      this.template.templateStatus = ''
      this.template.templateType = ''
      this.template.templateArr = [{
        question: '',
        answer: '',
      }]
    },
    closeEditDialog() {
      this.$refs.template.resetFields()
      this.showEdit = false
    },
    saveEditForm() {
      axios.post(`${apiBaseUrl}/template/add`, this.template,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$refs.template.resetFields()
            this.showEdit = false
            this.$emit('refreshTemplate')
          } else {
            this.$message({
              message: '添加失败',
              type: 'error'
            })
          }
        })
    },
  },
  beforeCreate() {
  },

  created() {

  },

  beforeMount() {

  },

  mounted() {

  },

  beforeUpdate() {

  },

  updated() {

  },

  beforeDestroy() {

  },
  destroyed() {

  },

  activated() {

  },
}


</script>

<style scoped>
/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  #bb >>> .el-dialog {
    width: 83%;
  }
}
</style>




// WEBPACK FOOTER //
// src/manager/components/TemplateAdd.vue